import clsx from "clsx";
import { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import WarningIcon from "@mui/icons-material/Warning";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Grid } from "@mui/material";

import { ROUTE_STATUS } from "../../../consts/routeDetails";

import { View } from "../../View";
import { getLocationVolume } from "../../../utils/locations";

import {
  routeSelector,
  locationVolumesSelector,
} from "../../../reducers/matrixProfile/selectors";

import { CheckmarkIcon, ClockIcon, ParcelIcon } from "../../Icons";

const useStyles = makeStyles({
  container: {
    maxHeight: "40px",
    width: "55px",
  },
  line: {
    display: "flex",
    height: "12px",
    lineHeight: "12px",
    fontSize: "12px",
  },
  icon: {
    color: "white",
    height: "12px",
    width: "12px",
  },
  iconContainer: {
    paddingLeft: "4px",
  },
  green: {
    backgroundColor: "#8AC149",
  },
  red: {
    backgroundColor: "#DC0032",
  },
  top: {
    borderRadius: "0 0.125rem 0 0",
  },
  bottom: {
    borderRadius: "0 0 0.125rem 0",
  },
  marginTop: {
    marginTop: "2px",
  },
});

export const LocationVolumes = memo(({ routeCode, locationCode }) => {
  const styles = useStyles();
  const volumes = useSelector(locationVolumesSelector);
  const route = useSelector(routeSelector(routeCode));
  const [volume, setVolume] = useState({});

  const getRouteStatusIcon = (routeStatus) => {
    switch (routeStatus) {
      case ROUTE_STATUS.DUTY_EXCEEDED:
        return <WarningIcon className={clsx(styles.icon, styles.red)} />;
      case ROUTE_STATUS.OPPORTUNITY:
        return <ClockIcon className={clsx(styles.icon, styles.red)} />;
      case ROUTE_STATUS.OK:
        return <CheckmarkIcon className={clsx(styles.icon, styles.green)} />;
      default:
        return;
    }
  };

  useEffect(() => {
    setVolume(
      getLocationVolume({
        locationCode,
        volumes,
      })
    );
  }, [locationCode, volumes]);

  return !!volume.stops ? (
    <Grid container item direction={"column"} className={styles.container}>
      <Grid item container justifyContent={"flex-column"}>
        <Grid
          item
          className={clsx(styles.line)}
          container
          justifyContent={"flex-end"}
        >
          {volume.stops}
          <View className={clsx(styles.iconContainer, styles.top)}>
            <LocationOnIcon className={clsx(styles.icon, styles.green)} />
          </View>
        </Grid>
        <Grid
          item
          className={clsx(styles.line, styles.marginTop)}
          container
          justifyContent={"flex-end"}
        >
          {volume.parcels}
          <View className={clsx(styles.iconContainer, styles.top)}>
            <ParcelIcon className={clsx(styles.icon, styles.green)} />
          </View>
        </Grid>
        {route?.routeOptimisation?.routeStatus && (
          <Grid
            item
            container
            className={clsx(styles.line, styles.marginTop)}
            justifyContent={"flex-end"}
          >
            <View className={clsx(styles.iconContainer)}>
              {getRouteStatusIcon(route.routeOptimisation.routeStatus)}
            </View>
          </Grid>
        )}
      </Grid>
    </Grid>
  ) : null;
});
